/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class MenuController {
   $scope: any
   appState: any
   mediaQueryService: any
   registerMenu: any
   constructor($scope: any, menuService: any, mediaQueryService: any, appState: any) {
      this.$onInit = this.$onInit.bind(this)
      this.handleAppStateChange = this.handleAppStateChange.bind(this)
      this.processLayoutChange = this.processLayoutChange.bind(this)
      this.$scope = $scope
      this.mediaQueryService = mediaQueryService
      this.appState = appState
      this.$scope.floating = false
      this.$scope.pinned = false // this overrides float, so we could add a 'do not float' pin icon and force the thing to stay fixed
      this.$scope.content = {}
      this.registerMenu = menuService.registerMenu
      this.appState.on('apply', () => {
         return this.handleAppStateChange()
      })
   }

   $onInit() {
      this.$scope.type = this.$scope.type || 'menu'
      if (this.$scope.pinned && this.$scope.floating) {
         this.$scope.open = true
         this.$scope.floating = true
      }
      this.registerMenu(this.$scope)
      // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
      this.processLayoutChange(this.mediaQueryService.current)
      return this.mediaQueryService.on('change', (newSize: any, sizeDiff: any) => {
         return this.processLayoutChange(newSize, sizeDiff)
      })
   }

   handleAppStateChange() {
      if (this.$scope.closeOnAppstateChange && this.$scope.floating) {
         return this.$scope.closeMenu()
      }
   }

   // this won't happen that often during a user session - but it happens on site load at least once
   // 'openSize' has priority over 'closeSize' - this is needed because there is overlap in sizes (see mediaQueryService)
   // when size changes, user preference (open/close) is ignored
   processLayoutChange(newSize: any, sizeDiff: any) {
      this.$scope.size = newSize

      if (angular.isArray(this.$scope.floatSize)) {
         this.$scope.floating = _.any(this.$scope.floatSize, (s: any) => (s === newSize.size) || (s === 'any'))
      }
      if (this.$scope.floating) {
         this.$scope.floating = true
         this.$scope.open = true
      }

      let shouldOpen = false
      if (angular.isArray(this.$scope.openSize)) {
         shouldOpen = _.any(this.$scope.openSize, (s: any) => (s === newSize.size) || (s === 'any'))
      }
      let shouldClose = false
      if (angular.isArray(this.$scope.closeSize)) {
         shouldClose = _.any(this.$scope.closeSize, (s: any) => (s === newSize.size) || (s === 'any'))
      }
      if (shouldClose && !shouldOpen) { //checks if it should be open for the new layout size
         return this.$scope.closeMenu()
      } else if (shouldOpen) {
         return this.$scope.openMenu()
      }
   }
}

MenuController.$inject = ['$scope', 'menuManagerService', 'mediaQueryService', 'appStateService']

angular.module('summonApp.controllers')
   .controller('MenuCtrl', MenuController)

